<template>
  <modal :show="show" @close="close()" id="fund-edit">
    <div class="modal-head">
      <h2>Edit Fund</h2>
    </div>

    <div class="modal-content">
      <form @submit.prevent="update()">
        <div class="form-control">
          <label for="type">Fund Type</label>
          <select v-model="input.type" name="type" id="type" disabled>
            <option value disabled selected>--</option>
            <option v-for="(type, i) in types" :key="i">{{ type }}</option>
          </select>
        </div>

        <div class="form-control">
          <label for="projected">Projected</label>
          <currency-input
            v-model="input.projected"
            id="projected"
            :disabled="enterActual.includes(input.type)"
          ></currency-input>
        </div>

        <div class="form-control">
          <label for="actual">Actual</label>
          <currency-input
            v-model="input.actual"
            id="projected"
          ></currency-input>
        </div>

        <div class="form-control">
          <label for="purpose">Purpose</label>
          <input
            v-model="input.purpose"
            name="purpose"
            type="text"
            placeholder="(optional description)"
          />
        </div>

        <div v-if="this.showNegative && this.checkBalance" class="form-control excess">
          <label for="excess-reason">This fund exceeds the available amount for this month (${{this.toBalance.toLocaleString()}})</label>
          <input
            v-model="excessReason.description"
            name="excess-reason"
            type="text"
            required
            placeholder="Please provide a brief explanation for the excess funds"
          />
        </div>

        <button class="button button-green">Save</button>
        <button @click.prevent="close()" class="button button-gray">Close</button>
      </form>
    </div>
  </modal>
</template>

<script>
import Modal from "@/components/ui/Modal";
import CurrencyInput from "@/components/ui/CurrencyInput";

export default {
  name: "FundEdit",
  props: ["show", "fund", "budget", "toBalance"],
  components: {
    Modal,
    CurrencyInput
  },
  async mounted() {
    // Get unique campaign / account types based on what's been added to the client
    let clientId = this.$route.params.clientId;
    let response = await this.$http.get("/clients/" + clientId + "/campaigns");
    this.types = response.data
      // Call Tracking does not need to be in this list
      .filter(row => row.type !== "Call Tracking")
      // Strip unnecessary fields
      .map(row => row.type)
      // Remove duplicates
      .filter((value, i, self) => self.indexOf(value) === i)
      // Alphabetize
      .sort();
  },
  data() {
    return {
      input: {
        type: "",
        projected: 0,
        actual: 0,
        purpose: ""
      },
      showNegative: false,
      currentActual: "",
      currentProjected: "",
      excessReason: {
        type: "Excess Funds",
        description: ""
      },
      types: [],
      enterActual: ["Google Ads", "Google Adwords"]
    };
  },
  computed: {
    negativeBalance() {
      if(
        ( this.enterActual.includes(this.input.type) && ((this.toBalance + this.currentActual) - this.input.actual < 0) ) ||
        ( !this.enterActual.includes(this.input.type) && ((this.toBalance + this.currentProjected) - this.input.projected < 0) )
      ) {
        return true;
      }
      return false;
    },
    checkBalance() {
      if(this.showNegative) {
        if(
          ( this.enterActual.includes(this.input.type) && ((this.toBalance + this.currentActual) - this.input.actual < 0) ) ||
          ( !this.enterActual.includes(this.input.type) && ((this.toBalance + this.currentProjected) - this.input.projected < 0) )
        ) {
          return true;
        }
        return false;
      }
    }
  },
  watch: {
    fund: {
      handler(val) {
        this.input = JSON.parse(JSON.stringify(val));
        // Fix for null values
        this.input.projected = this.input.projected || 0;
        this.input.actual = this.input.actual || 0;
        this.currentActual = this.input.actual || 0;
        this.currentProjected = this.input.projected || 0;
      }
    }
  },
  methods: {
    async update() {
      if(this.negativeBalance && !this.showNegative) {
        return this.showNegative = true;
      }
      let response = await this.$http.put(
        "/paid-media-budgets/" + this.budget.id + "/funds/" + this.fund.id,
        this.input
      );

      if(this.negativeBalance) {
        let logResponse = await this.$http.post(
          "/paid-media-budgets/" + this.$route.params.clientId + "/logs",
          this.excessReason
        );
      }

      this.$emit("update");
      this.$emit("close");
    },
    close() {
      this.$emit("close");
    }
  }
};
</script>
<style lang="scss">
  #fund-edit {
    .excess {
      label {
        color: $red;
        font-weight: 700;
      }
      input {
        border-color: $red;
      }
    }
  }
</style>
